import Api from './api.service';

export default {
  destroy: (id) => Api.delete(`users/${id}`),
  get: (params = {}) => Api.get('users', { params }),
  put: (data, id) => Api.put(`users/${id}`, data),
  store: (data) => Api.post('users', data),
  changeStatus: (data, id) => Api.put(`users/${id}/change-status`, data),
};
